module.exports = __webpack_public_path__ + "static/VegaDream-2498d4b565a93ff6bacec040781888fd.png";